<template>  
  <div class="container margin-top-20">
    <div v-if="loading" class="margin-top-20 center">
      <div class="row margin-bottom-10 margin-top-20 mybookings-header">
        <div class="col-12">
          <div class="card afas-gold">
            <div class="card-content">
              <h5 class="margin-top-10 margin-bottom-10 teal-text">.</h5>
              <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
            </div>
          </div>
          <div class="progress">
            <div class="indeterminate"></div>
          </div>
        </div>
      </div>
      <div class="row card-panel" style="padding: 30px; min-height: 1000px">
        <div class="col-12">
          <div class="preloader-wrapper big active" style="margin-top: 125px;">
            <div class="spinner-layer spinner-green-only">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div>
              <div class="gap-patch">
                <div class="circle"></div>
              </div>
              <div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
          <p class="grey-text">Preparing. One moment please...</p>
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="noDisplayName && !loading" class="row">
        <div class="signup container">
          <div class="row card-panel" style="padding: 30px;">
            <div class="col-12">
              <div class="row" style="margin-top: 45px">
                <div class="col-12 center">
                  <h2 class="red-text">NO USERNAME</h2>
                  <p>You did not yet set up a username for this account. Go to the settings page to add a username to your profile.</p>
                  <router-link :to="{ name: 'Profile' }">
                    <button class="btn waves-effect waves-light teal margin-top-20">Go To Settings</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <div v-if="selectedOffice && !noDisplayName && selectedOffice.hourly != true" class="row">
        <div class="col-12">
          <div class="row margin-bottom-10 margin-top-20 mybookings-header">
            <div class="col-12">
              <div class="card afas-gold">
                <div class="card-content">
                  <h5 class="margin-top-10 margin-bottom-10 white-text">Office {{ selectedOffice.naam }}</h5>
                  <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
                </div>
              </div>
            </div>
          </div>
          <div class="calendar-card card" v-if="timestamps">
            <div class="card-content">
              <div class="row offices">
                <div class="col s12 m3 office" v-for="(timestamp, index) in timestamps" :key="index">
                  <div class="card" v-if="timestamp.morningBookings && timestamp.afternoonBookings && timestamp.bookings">
                    <div class="card-content grey-text" @click="openViewDayBookingsModal(timestamp.bookings)">
                      <div class="row">
                        <div class="col-12">
                          <span class="card-title teal-text" v-bind:class="{ 'font-bold': timestamp.day == 'Monday' }">{{ timestamp.day }}</span>
                          <p style="font-size: 16px;">
                            <span>{{ timestamp.time }}</span>
                          </p>
                        </div>
                      </div>
                      <!-- DOTS -->
                      <!-- <div class="row margin-bottom-10">
                        <div class="col-12" style="font-size: 1.2em">
                          <span
                            v-for="(free, index) in (selectedOffice.plekken - timestamp.morningBookings.length)"
                            :key="index"
                          >
                            <i class="material-icons teal-text">fiber_manual_record</i>
                          </span>
                          <span v-for="taken in (timestamp.morningBookings)" :key="taken.id">
                            <i class="material-icons red-text">fiber_manual_record</i>
                          </span>
                        </div>
                      </div> -->
                      <div class="row margin-bottom-10">
                        <div class="col-12 small-font-dot">
                          <span v-if="timestamp.morningBookings.length != 0 && timestamp.morningBookings.length < selectedOffice.plekken">
                            <span v-for="taken in (timestamp.morningBookings)" :key="taken.id">
                              <i class="material-icons red-text">fiber_manual_record</i>
                            </span>
                            <span v-for="(free, index) in (selectedOffice.plekken - timestamp.morningBookings.length)" :key="index">
                              <i class="material-icons afas-gold-text">fiber_manual_record</i>
                            </span>
                          </span>
                          <span v-if="timestamp.morningBookings.length >= selectedOffice.plekken">
                            <span v-for="taken in (timestamp.morningBookings)" :key="taken.id">
                              <i class="material-icons red-text">fiber_manual_record</i>
                            </span>
                          </span>
                          <span v-if="timestamp.morningBookings.length == 0">
                            <span v-for="(free, index) in (selectedOffice.plekken - 0)" :key="index">
                              <i class="material-icons afas-gold-text">fiber_manual_record</i>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class="row" v-if="selectedOffice.plekken >= timestamp.morningBookings.length">
                        <div class="col-12" style="font-size: 1rem">
                          <span :class="{ 'orange-text': (selectedOffice.plekken - timestamp.morningBookings.length == 1), 'red-text': (selectedOffice.plekken - timestamp.morningBookings.length < 1), 'teal-text': (selectedOffice.plekken - timestamp.morningBookings.length > 1) }">{{ selectedOffice.plekken - timestamp.morningBookings.length }} / {{ selectedOffice.plekken }} Free Spots | Morning</span>
                        </div>
                      </div>
                      <div class="row" v-if="selectedOffice.plekken < timestamp.morningBookings.length">
                        <div class="col-12" style="font-size: 1rem">
                          <span class="red-text">Overbooked | Morning
                          </span>
                        </div>
                      </div>
                      <!-- DOTS -->
                      <!-- DOTS -->
                      <!-- <div class="row margin-bottom-10">
                        <div class="col-12" style="font-size: 1.2em">
                          <span
                            v-for="(free, index) in (selectedOffice.plekken - timestamp.afternoonBookings.length)"
                            :key="index"
                          >
                            <i class="material-icons teal-text">fiber_manual_record</i>
                          </span>
                          <span v-for="taken in (timestamp.afternoonBookings)" :key="taken.id">
                            <i class="material-icons red-text">fiber_manual_record</i>
                          </span>
                        </div>
                      </div> -->
                      <div class="row margin-bottom-10">
                        <div class="col-12 small-font-dot">
                          <span v-if="timestamp.afternoonBookings.length != 0 && timestamp.afternoonBookings.length < selectedOffice.plekken">
                            <span v-for="taken in (timestamp.afternoonBookings)" :key="taken.id">
                              <i class="material-icons red-text">fiber_manual_record</i>
                            </span>
                            <span v-for="(free, index) in (selectedOffice.plekken - timestamp.afternoonBookings.length)" :key="index">
                              <i class="material-icons afas-gold-text">fiber_manual_record</i>
                            </span>
                          </span>
                          <span v-if="timestamp.afternoonBookings.length >= selectedOffice.plekken">
                            <span v-for="taken in (timestamp.afternoonBookings)" :key="taken.id">
                              <i class="material-icons red-text">fiber_manual_record</i>
                            </span>
                          </span>
                          <span v-if="timestamp.afternoonBookings.length == 0">
                            <span v-for="(free, index) in (selectedOffice.plekken - 0)" :key="index">
                              <i class="material-icons afas-gold-text">fiber_manual_record</i>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class="row" v-if="selectedOffice.plekken >= timestamp.afternoonBookings.length">
                        <div class="col-12" style="font-size: 1rem">
                          <span :class="{ 'orange-text': (selectedOffice.plekken - timestamp.afternoonBookings.length == 1), 'red-text': (selectedOffice.plekken - timestamp.afternoonBookings.length < 1), 'teal-text': (selectedOffice.plekken - timestamp.afternoonBookings.length > 1) }">{{ selectedOffice.plekken - timestamp.afternoonBookings.length }} / {{ selectedOffice.plekken }} Free Spots | Afternoon</span>
                        </div>
                      </div>
                      <div class="row" v-if="selectedOffice.plekken < timestamp.afternoonBookings.length">
                        <div class="col-12" style="font-size: 1rem">
                          <span class="red-text">Overbooked | Afternoon
                          </span>
                        </div>
                      </div>
                      <!-- DOTS -->
                    </div>
                    <div class="card-action" v-if="user.permission > 100 && !(selectedOffice.id == 'XWacK2K2xJ7Ncb6ZyVM' && timestamp.day == 'Thursday')">
                      <!-- OLD SITUATION WITH MAXIMUM BOOKINGS -->
                      <!-- <a
                        v-if="(selectedOffice.plekken - timestamp.morningBookings.length > 0) && (selectedOffice.plekken - timestamp.afternoonBookings.length > 0)"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openAddSecretaryBookingModal(selectedOffice.id, timestamp.timestamp, 1)"
                      >Make a Booking</a>
                      <a
                        v-if="(selectedOffice.plekken - timestamp.morningBookings.length > 0) && (selectedOffice.plekken - timestamp.afternoonBookings.length == 0)"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openAddSecretaryBookingModal(selectedOffice.id, timestamp.timestamp, 2)"
                      >Make a Booking</a>
                      <a
                        v-if="(selectedOffice.plekken - timestamp.morningBookings.length == 0) && (selectedOffice.plekken - timestamp.afternoonBookings.length > 0)"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openAddSecretaryBookingModal(selectedOffice.id, timestamp.timestamp, 3)"
                      >Make a Booking</a>
                      -->
                      <a v-if="(selectedOffice.limiet - timestamp.morningBookings.length <= 0) && (selectedOffice.limiet - timestamp.afternoonBookings.length <= 0)" class="btn-small btn-block waves-effect waves-light black" style="width: 100%">FULL</a>
                      <!-- OLD SITUATION WITH MAXIMUM BOOKINGS -->
                      <!-- NEW SITUATION ALWAYS ABLE TO BOOK -->
                      <a v-if="(selectedOffice.limiet - timestamp.morningBookings.length > 0) && (selectedOffice.limiet - timestamp.afternoonBookings.length > 0)" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestSecretaryBookingModal(selectedOffice.id, timestamp.timestamp, 1)">Request a Booking</a>
                      <a v-if="(selectedOffice.limiet - timestamp.morningBookings.length > 0) && (selectedOffice.limiet - timestamp.afternoonBookings.length <= 0)" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestSecretaryBookingModal(selectedOffice.id, timestamp.timestamp, 2)">Request a Booking</a>
                      <a v-if="(selectedOffice.limiet - timestamp.morningBookings.length <= 0) && (selectedOffice.limiet - timestamp.afternoonBookings.length > 0)" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestSecretaryBookingModal(selectedOffice.id, timestamp.timestamp, 3)">Request a Booking</a>
                      <!-- NEW SITUATION ALWAYS ABLE TO BOOK -->
                    </div>
                    <div class="card-action" v-if="user.permission == 100 && !(selectedOffice.id == 'XWacK2K2xJ7Ncb6ZyVM' && timestamp.day == 'Thursday')">
                      <!-- OLD SITUATION WITH MAXIMUM BOOKINGS -->
                      <!-- <a
                        v-if="(selectedOffice.plekken - timestamp.morningBookings.length > 0) && (selectedOffice.plekken - timestamp.afternoonBookings.length > 0 && !timestamp.picked)"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 1)"
                      >Request a Booking</a>
                      <a
                        v-if="(selectedOffice.plekken - timestamp.morningBookings.length > 0) && (selectedOffice.plekken - timestamp.afternoonBookings.length == 0 && !timestamp.picked)"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 2)"
                      >Request a Booking</a>
                      <a
                        v-if="(selectedOffice.plekken - timestamp.morningBookings.length == 0) && (selectedOffice.plekken - timestamp.afternoonBookings.length > 0 && !timestamp.picked)"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 3)"
                      >Request a Booking</a>
                       -->
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) <= 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) <= 0)" class="btn-small btn-block waves-effect waves-light black" style="width: 100%">FULL</a>
                      <!-- OLD SITUATION WITH MAXIMUM BOOKINGS -->
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) > 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) > 0) && !timestamp.picked" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 1)">Request a Booking</a>
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) > 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) <= 0) && !timestamp.picked" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 2)">Request a Booking</a>
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) <= 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) > 0) && !timestamp.picked" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 3)">Request a Booking</a>
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) > 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) > 0) && timestamp.picked && timestamp.morning == true && timestamp.afternoon == false" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 3)">Request a Booking</a>
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) > 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) > 0) && timestamp.picked && timestamp.morning == false && timestamp.afternoon == true" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openRequestBookingModal(selectedOffice.id, timestamp.timestamp, 2)">Request a Booking</a>
                      <a v-if="((selectedOffice.limiet - timestamp.morningBookings.length) > 0) && ((selectedOffice.limiet - timestamp.afternoonBookings.length) > 0) && timestamp.picked && timestamp.morning && timestamp.afternoon" class="btn-small btn-block waves-effect waves-light grey" style="width: 100%; font-size: 0.7em">Already a Booking</a>
                      <!-- <a
                        v-if="(selectedOffice.plekken - timestamp.bookings.length > 0) && !timestamp.picked"
                        class="waves-effect waves-light teal btn-small btn-block"
                        style="width: 100%"
                        @click="openAddBookingModal(selectedOffice.id, timestamp.timestamp)"
                      >Book Now</a> -->
                      <!-- <a
                        v-if="(selectedOffice.plekken - timestamp.bookings.length > 0) && !timestamp.picked"
                        class="btn-small btn-block waves-effect waves-light grey"
                        style="width: 100%; font-size: 0.7em"
                      >Temporarily Unavailable</a> -->
                    </div>
                    <div class="card-action" v-if="(selectedOffice.id == 'XWacK2K2xJ7Ncb6ZyVM' && timestamp.day == 'Thursday')">
                      <a v-if="(selectedOffice.id == 'XWacK2K2xJ7Ncb6ZyVM' && timestamp.day == 'Thursday')" class="red btn-small btn-block" style="width: 100%">CLOSED TODAY</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- HOURLY BOOKING -->
      <!-- HOURLY BOOKING -->
      <div v-if="selectedOffice && !noDisplayName && selectedOffice.hourly == true" class="row">
        <div class="col-12">
          <div class="row margin-bottom-10 margin-top-20 mybookings-header">
            <div class="col-12">
              <div class="card afas-gold">
                <div class="card-content">
                  <h5 class="margin-top-10 margin-bottom-10 white-text">Office {{ selectedOffice.naam }}</h5>
                  <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
                </div>
              </div>
            </div>
          </div>
          <div class="calendar-card card" v-if="timestamps">
            <div class="card-content">
              <div class="row offices">
                <div class="col s12 m3 office" v-for="(timestamp, index) in timestamps" :key="index">
                  <div class="card" v-if="timestamp.morningBookings && timestamp.afternoonBookings && timestamp.bookings">
                    <!-- <div class="card-content grey-text" @click="openViewDayBookingsModal(timestamp.bookings)"> -->
                    <div class="card-content grey-text">
                      <div class="row">
                        <div class="col-12">
                          <span class="card-title teal-text" v-bind:class="{ 'font-bold': timestamp.day == 'Monday' }">{{ timestamp.day }}</span>
                          <p style="font-size: 16px;">
                            <span>{{ timestamp.time }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="card-action">
                        <a v-if="timestamp.picked" class="btn-small btn-block waves-effect waves-light grey" style="width: 100%; font-size: 0.5em">Already Booked</a>
                        <a v-if="!timestamp.picked" class="waves-effect waves-light teal btn-small btn-block" style="width: 100%" @click="openCheckAvailabilityModal(selectedOffice.id, timestamp.timestamp, 3)">Check Availability</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- HOURLY BOOKING -->
      <!-- HOURLY BOOKING -->

    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import addBooking from "@/components/modals/addBooking";
import requestBooking from "@/components/modals/requestBooking";
import addSecretaryBooking from "@/components/modals/addSecretaryBooking";
import requestSecretaryBooking from "@/components/modals/requestSecretaryBooking";
import checkAvailability from "@/components/modals/checkAvailability";
import viewDayBookings from "@/components/modals/viewDayBookings";
import firebase from "firebase";
export default {
  name: "Calendar",
  data() {
    return {
      lastMidnight: null,
      timestamps: [],
      timestampsWithBookings: [],
      user: null,
      noDisplayName: false,
      loading: true
    }
  },
  computed: {
    ...mapGetters([
      "allOffices",
      "selectedOffice",
      "officeBookings",
      "myBookings",
    ]),
  },
  methods: {
    ...mapActions([
      "getAllOffices",
      "setOffice",
      "setOfficeBookings",
      "setMyBookings",
    ]),
    getLastMidnightTimestamp() {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      this.lastMidnight = d.getTime();
      this.createTimestamps();
    },
    containsParkeren() {
    if (this.selectedOffice && typeof this.selectedOffice.naam && typeof this.selectedOffice.naam === 'string') {
      return this.selectedOffice.naam.toLowerCase().includes('parkeren');
    }
      return false;
    },
    createTimestamps() {

      console.log('officeid is: ' + this.selectedOffice.officeid)

      var days = 22;

      //PARKEREN
      if(this.containsParkeren()){
        days = 9
      } 

      if(this.containsParkeren() && this.user.permission > 100){
        days = 21
      }

      if(this.selectedOffice.officeid == '51'){
        days = 365
      } 
      //PARKEREN
      if(this.selectedOffice.naam == 'fitness' && this.user.email != "c.spel@burdock.com"){
        days = 21
      } 
      if(this.user.email == "c.spel@burdock.com" || this.user.email == "caroline.spel@pnoconsultants.com"){
        days = 180
      }
      if(this.user.email == "rutger.beerens@pnoconsultants.com"){
        
      }
      var timestamps = [];
      var timestamp = this.lastMidnight;
      for (var i = 0; i < days; i++) {
        var index = this.myBookings.findIndex(x => x.timestamp == timestamp && x.officeid == this.selectedOffice.id);
        if (index > -1) {
          var matches = this.myBookings.filter(x => x.timestamp == timestamp);
          console.log(matches)
          //LOOP THROUGH FITNESS BOOKINGS
          if (this.selectedOffice.hourly == true) {
            console.log("Hourly Office")
            if(matches.length > 20) {
              timestamps.push({
                day: i + 1,
                timestamp: timestamp,
                time: moment(timestamp).format("Do MMM"),
                day: moment(timestamp).format("dddd"),
                picked: true,
                morning: true,
                afternoon: true,
              });
            } else {
              timestamps.push({
                day: i + 1,
                timestamp: timestamp,
                time: moment(timestamp).format("Do MMM"),
                day: moment(timestamp).format("dddd"),
                picked: false,
              });
            }
          } else {
            //LOOP THROUGH OFFICE BOOKINGS
            if(matches.length > 1) {
              console.log('Morning & Afternoon Bookings')
              timestamps.push({
                day: i + 1,
                timestamp: timestamp,
                time: moment(timestamp).format("Do MMM"),
                day: moment(timestamp).format("dddd"),
                picked: true,
                morning: true,
                afternoon: true,
              });
            } else if (this.myBookings[index].shift == 2) {
              console.log('Morning Booking')
              console.log('Not Yet an Afternoon Booking')
              timestamps.push({
                day: i + 1,
                timestamp: timestamp,
                time: moment(timestamp).format("Do MMM"),
                day: moment(timestamp).format("dddd"),
                picked: true,
                morning: true,
                afternoon: false,
              });
            } else if (this.myBookings[index].shift == 3) {
              console.log('Afternoon Booking')
              var index3 = timestamps.findIndex(x => x.timestamp == timestamp);
              console.log('Not Yet a Morning Booking')
              timestamps.push({
                day: i + 1,
                timestamp: timestamp,
                time: moment(timestamp).format("Do MMM"),
                day: moment(timestamp).format("dddd"),
                picked: true,
                morning: false,
                afternoon: true,
              });
            } else {
              console.log('Full Day Booking')
              timestamps.push({
                day: i + 1,
                timestamp: timestamp,
                time: moment(timestamp).format("Do MMM"),
                day: moment(timestamp).format("dddd"),
                picked: true,
                morning: true,
                afternoon: true,
              });
            }
          }
        } else {
          timestamps.push({
            day: i + 1,
            timestamp: timestamp,
            time: moment(timestamp).format("Do MMM"),
            day: moment(timestamp).format("dddd"),
            picked: false,
          });
        }
        timestamp += 86400000;
      }
      this.timestamps = timestamps;
      this.orderTimestamps();
    },
    openAddBookingModal(officeid, timestamp) {
      this.$modal.show(
        addBooking, { office_id: officeid, timestamp: timestamp }, {
          adaptive: true,
          draggable: true,
          minWidth: Number(800),
          minHeight: Number(485),
        }, {
          "before-open": this.beforeOpen,
          "before-close": this.beforeClose,
        }
      );
    },
    openRequestBookingModal(officeid, timestamp, shift) {
      this.$modal.show(
        requestBooking, { office_id: officeid, timestamp: timestamp, shifts_possible: shift }, {
          adaptive: true,
          draggable: true,
          minWidth: Number(800),
          minHeight: Number(600),
        }, {
          "before-open": this.beforeOpen,
          "before-close": this.beforeClose,
        }
      );
    },
    openAddSecretaryBookingModal(officeid, timestamp, shift) {
      this.$modal.show(
        addSecretaryBooking, { office_id: officeid, timestamp: timestamp, shifts_possible: shift }, {
          adaptive: true,
          draggable: true,
          minHeight: Number(680),
        }, {
          "before-open": this.beforeOpen,
          "before-close": this.beforeClose,
        }
      );
    },
    openRequestSecretaryBookingModal(officeid, timestamp, shift) {
      this.$modal.show(
        requestSecretaryBooking, { office_id: officeid, timestamp: timestamp, shifts_possible: shift }, {
          adaptive: true,
          draggable: true,
          minHeight: Number(715),
        }, {
          "before-open": this.beforeOpen,
          "before-close": this.beforeClose,
        }
      );
    },
    openCheckAvailabilityModal(officeid, timestamp, shift) {
      console.log('Check Availability Modal')
      this.$modal.show(
        checkAvailability, { office_id: officeid, timestamp: timestamp, shifts_possible: shift }, {
          adaptive: true,
          draggable: true,
          minHeight: Number(1050),
        }, {
          "before-open": this.beforeOpen,
          "before-close": this.beforeClose,
        }
      );
    },
    openViewDayBookingsModal(officebookings) {
      console.log("Opening View Day Bookings Modal");
      if (officebookings && officebookings.length > 0) {
        this.$modal.show(
          viewDayBookings, { bookings: officebookings }, {
            adaptive: true,
            draggable: true,
            minWidth: Number(1000),
            minHeight: Number(600),
          },
        );
      } else {
        console.log("No bookings on this day yet")
      }
    },
    orderTimestamps() {

      //INCLUDE SATURDAY AND SUNDAY
      this.timestamps = this.timestamps.filter(x => x.day != 'Saturday' && x.day != 'Sunday');
      //INCLUDE SATURDAY AND SUNDAY

      //MARKS ISSUE
      // var marksbookings = this.officeBookings.filter((x) => x.employee === 'Mark Kuik')
      // console.log(marksbookings)
      //MARKS ISSUE

      for (var i = 0; i < this.timestamps.length; i++) {

        //BEFORE MARKS ISSUE
        //SPLIT BOOKINGS INTO MORNING AND AFTERNOON
        // let bookings = this.officeBookings.filter(
        //   (x) => x.timestamp === this.timestamps[i].timestamp
        // );
        // let morningBookings = this.officeBookings.filter(
        //   (x) => x.timestamp === this.timestamps[i].timestamp && (x.shift == 2 || x.shift == 1)
        // );
        // let afternoonBookings = this.officeBookings.filter(
        //   (x) => x.timestamp === this.timestamps[i].timestamp && (x.shift == 3 || x.shift == 1)
        // );
        //BEFORE MARKS ISSUE

        // let legacy_bookings_array = this.officeBookings.filter(
        //   (x) => x.minus_one_day_timestamp != null
        // );

        // let wilma_bookings = this.officeBookings.filter(
        //   (x) => x.employee == 'Wilma'
        // )

        // let legacy_bookings = legacy_bookings_array.filter(
        //   (x) => x.minus_one_day_timestamp === this.timestamps[i].timestamp || x.minus_one_day_timestamp === this.timestamps[i].timestamp + 3600000 || x.minus_one_day_timestamp === this.timestamps[i].timestamp - 3600000 && x.minus_one_day_timestamp != null
        // );
        // let legacy_morningBookings = legacy_bookings_array.filter(
        //   (x) => (x.minus_one_day_timestamp === this.timestamps[i].timestamp || x.minus_one_day_timestamp === this.timestamps[i].timestamp + 3600000 || x.minus_one_day_timestamp === this.timestamps[i].timestamp - 3600000) && (x.shift == 2 || x.shift == 1) && x.minus_one_day_timestamp != null
        // );
        // let legacy_afternoonBookings = legacy_bookings_array.filter(
        //   (x) => (x.minus_one_day_timestamp === this.timestamps[i].timestamp || x.minus_one_day_timestamp === this.timestamps[i].timestamp + 3600000 || x.minus_one_day_timestamp === this.timestamps[i].timestamp - 3600000) && (x.shift == 3 || x.shift == 1)  && x.minus_one_day_timestamp != null
        // );

        let bookings = this.officeBookings.filter(
          (x) => x.timestamp === this.timestamps[i].timestamp || x.timestamp === this.timestamps[i].timestamp + 3600000 || x.timestamp === this.timestamps[i].timestamp - 3600000 && x.minus_one_day_timestamp == null
        );
        // let morningBookings = this.officeBookings.filter(
        //   (x) => (x.timestamp === this.timestamps[i].timestamp || x.timestamp === this.timestamps[i].timestamp + 3600000 || x.timestamp === this.timestamps[i].timestamp - 3600000) && (x.shift == 2 || x.shift == 1) && x.minus_one_day_timestamp == null
        // );
        // let afternoonBookings = this.officeBookings.filter(
        //   (x) => (x.timestamp === this.timestamps[i].timestamp || x.timestamp === this.timestamps[i].timestamp + 3600000 || x.timestamp === this.timestamps[i].timestamp - 3600000) && (x.shift == 3 || x.shift == 1) && x.minus_one_day_timestamp == null
        // );
        

        // this.timestamps[i].morningBookings    = morningBookings.concat(legacy_morningBookings);
        // this.timestamps[i].afternoonBookings  = afternoonBookings.concat(legacy_afternoonBookings);

        //SPLIT BOOKINGS INTO MORNING AND AFTERNOON
        // this.timestamps[i].bookings           = bookings.concat(legacy_bookings);
        this.timestamps[i].bookings           = bookings

        this.timestamps[i].morningBookings    = this.timestamps[i].bookings.filter(x => x.shift == 2 || x.shift == 1);
        this.timestamps[i].afternoonBookings  = this.timestamps[i].bookings.filter(x => x.shift == 3 || x.shift == 1);

        console.log("=====================================")
        console.log("=====================================")
        console.log('Timestamp: ' + this.timestamps[i].timestamp)
        console.log(moment.unix((this.timestamps[i].timestamp)/1000).format('llll'))
        console.log('Bookings: ' + this.timestamps[i].bookings.length)
        console.log('Morning Bookings: ' + this.timestamps[i].morningBookings.length)
        console.log('Afternoon Bookings: ' + this.timestamps[i].afternoonBookings.length)

        for (let index = 0; index < bookings.length; index++) {
          console.log("Shift:")
          console.log(bookings[index].shift)
          console.log(moment.unix((bookings[index].timestamp)/1000).format('llll'))
        }

        console.log(this.timestamps[i])
        console.log("<<<<<<<<<<<<<<>>>>>>>>>>>>>>")

      }

      this.loading = false;

    },
    beforeOpen(event) {
      console.log("Opening...");
    },
    async beforeClose(event) {
      console.log("Closing...");
      await this.setOfficeBookings(this.$route.params.officeid);
      await this.setMyBookings();
      this.getLastMidnightTimestamp();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  async created() {
    this.user = await firebase.auth().currentUser;
    if (this.user.displayName) {
      this.noDisplayName = false;
      await this.getAllOffices(this.$route.params.locationname);
      await this.setOffice(this.$route.params.officeid);
      await this.setOfficeBookings(this.$route.params.officeid);
      await this.setMyBookings();
      this.getLastMidnightTimestamp();
      console.log(this.officeBookings)
      console.log(this.myBookings)
      console.log(this.selectedOffice)
    } else {
      this.noDisplayName = true;
      this.loading = false;
    }
  },
};
 
</script>
<style>
.calendar-card {
  position: relative;
}

.mybookings-header .back-button {
  position: absolute;
  top: 28px;
  right: 15px;
}

.signup {
  max-width: 400px;
  margin-top: 60px;
}

.signup h2 {
  font-size: 1.4em;
}

.signup .field {
  margin-bottom: 16px;
}

.calendar-card .card-content:hover {
  background-color: #F8F8F8;
}

</style>



// WEBPACK FOOTER //
// src/components/calendar/Calendar.vue